import { Chip, makeStyles, Typography } from "@material-ui/core";
import get from "lodash/get";
import React from "react";
import { useRecordContext } from "react-admin";

interface IBackupOperatorChipField {
  source: string;
  chipSource: string;
  label?: string;
}

const useStyles = makeStyles({
  root: {
    padding: "6px 0 4px",
    "& .MuiChip-root": {
      marginLeft: 8,
    },
  },
});

const BackupOperatorChipField = ({
  source,
  chipSource,
}: IBackupOperatorChipField) => {
  const record = useRecordContext();
  const classes = useStyles();
  const datas = get(record, source);

  return (
    <>
      {datas && (
        <>
          {datas.length === 0 ? (
            <Typography>-</Typography>
          ) : (
            <div className={classes.root}>
              {datas.map((data: any, key: number) => (
                <Chip
                  key={key}
                  label={`${data[chipSource]} ${
                    data.contactNumber ? ` - ${data.contactNumber}` : ""
                  }`}
                />
              ))}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default BackupOperatorChipField;
